import React, { Component } from 'react'
import { string } from 'prop-types'
import { FULL_BLUE_LOGO, ISO_BLUE_LOGO } from '../../utils/constants'

const doodleContainerStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr',
  height: '200px'
}

const doodleCenterBoxStyle = {
  placeSelf: 'center'
}

const doodleImageStyle = {
  height: '120px',
  marginBottom: '40px'
}

class Doodle extends Component {
  constructor (props) {
    super(props)
    this.state = {
      site: props.site
    }
  }

  render () {
    const { site } = this.state
    const src = site.toUpperCase() !== 'CN' ? FULL_BLUE_LOGO : ISO_BLUE_LOGO
    return (
      <div style={doodleContainerStyle}>
        <div style={doodleCenterBoxStyle}>
          {src !== '' && (
            <img style={doodleImageStyle} src={src} />
          )}
        </div>
      </div>
    )
  }
}

Doodle.propTypes = {
  site: string
}

export default Doodle
